<h3 class="mat-h3">
  <ng-content></ng-content>
</h3>
